import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

import DedicatedDevelopmentTeam from 'app/components/Teams/DedicatedDevelopmentTeam';
import ExperiencedTeam from 'app/components/Teams/ExperiencedTeam';
import Faq from 'app/components/Teams/Faq';
import Solutions from 'app/components/Teams/Solutions';
import SuccesfulNumber from 'app/components/Teams/SuccesfulNumber';
import SuccesfulTeams from 'app/components/Teams/SuccesfulTeams';
import { SUCCESS_NUMBER } from 'app/helpers/apiEndpoint';
import REQUEST from 'app/helpers/http.service';

import 'styles/Home.module.css';
import AwardWinningBar from '../Home/AwardWinningBar';
import HeroSection from '../common/HeroSection';
import TestimonialData from '../warehouse/TestimonialData';

import OurDevelopers from './OurDevelopers';
const WriteGetInTouch = dynamic(
  () => import('app/components/writetous/WriteGetInTouch')
);

export default function ServiceDetail({
  data,
  awards,
  testimonials,
  offering,
}) {
  const [reqdata, setData] = useState({});

  const fetchData = async () => {
    try {
      const res = await REQUEST({
        method: 'GET',
        url: SUCCESS_NUMBER,
      });
      setData(res?.data?.data?.attributes);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      {data?.team_section1 && (
        <HeroSection data={data?.team_section1} isService={true} />
      )}
      {awards && (
        <AwardWinningBar section={awards} newdev={true} bgcolor={true} />
      )}
      {data?.team_section3 && (
        <Solutions section={data?.team_section3} offering={offering} />
      )}
      {data?.team_section4 && (
        <DedicatedDevelopmentTeam section4={data?.team_section4} />
      )}
      {data?.team_section5 && <SuccesfulTeams section={data?.team_section5} />}
      {data?.team_section6 && (
        <ExperiencedTeam
          section={data?.team_section6}
          section_content={data?.team_section6?.team_section6detail}
        />
      )}
      {reqdata && <SuccesfulNumber data={reqdata} />}
      {data?.team_section8 && <OurDevelopers section={data?.team_section8} />}
      {testimonials && (
        <div className="md:pb-[75px] pb-[30px]">
          <TestimonialData
            testimonials={testimonials}
            isNewTestimonial={true}
            removePadd={true}
          />
        </div>
      )}
      {data?.faq && (
        <div className="md:pb-[75px] pb-[30px]">
          <Faq section={data?.faq} />
        </div>
      )}
      <WriteGetInTouch />
    </div>
  );
}
